import { inferLanguageFromNavigator } from './infer-language-from-navigator';

export const inferLanguage = () => Promise.resolve(inferLanguageFromNavigator());
